<div class="container">

    <!-- HEADER -->
    <div class="page-header">
        <div class="page-header-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
        </div>
        <div style="flex:1">
            <h1>Edição de Produtos / Cotações</h1>
            <p>Selecione um produto para inserir nova cotação / editação</p>
        </div>

        <div class="header-actions-topo">
            <button type="button" class="btn-header-secundario" (click)="abrirCadastroProduto()" title="Ir para Cadastrar Produto">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                Cadastrar
            </button>

            <ng-container *ngIf="telaVisivel">
                <button type="button" class="btn-salvar-header" id="btnSalvar"
                        [disabled]="(!formAlterado && !extrasAlterados) || !cotacaoEditavel"
                        [title]="!cotacaoEditavel ? 'Sem permissão para editar (EDTCOT/EDTMAI não encontradas para o usuário)' : ((!formAlterado && !extrasAlterados) ? 'Nenhuma alteração para salvar' : 'Salvar alterações')"
                        (click)="salvarNovaCotacao()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                        <polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/>
                    </svg>
                    Salvar
                </button>
                <button type="button" class="btn-header-secundario" (click)="descartarEdicao()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"/></svg>
                    Descartar
                </button>
                <button *ngIf="form.ativo" type="button" class="btn-header-secundario" (click)="solicitarInativarProduto()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/></svg>
                    Inativar produto
                </button>
                <button *ngIf="!form.ativo" type="button" class="btn-header-secundario" (click)="solicitarReativarProduto()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 17.01"/></svg>
                    Reativar produto
                </button>
            </ng-container>
        </div>
    </div>

    <!-- BUSCA -->
    <div class="search-box" *ngIf="searchbox">

        <div class="search-row search-row-produto">

            <div class="field search-field search-fonte-menor">
                <label>PART NUMBER</label>
                <input
                        type="text"
                        id="partNumber"
                        [(ngModel)]="filtro.partNumber"
                        (blur)="recarregarInicial()"
                        (keyup)="onDigitarProduto()">
            </div>

            <div class="field search-field search-field-descricao">
                <label>DESCRIÇÃO</label>
                <input
                        type="text"
                        id="nome"
                        [(ngModel)]="filtro.nome"
                        (blur)="recarregarInicial()"
                        (keyup)="onDigitarProduto()">
            </div>

            <div class="field search-field">
                <label>CÓDIGO</label>
                <input
                        type="text"
                        id="codigo"
                        [(ngModel)]="filtro.codigo"
                        (blur)="recarregarInicial()"
                        (keyup)="onDigitarProduto()">
            </div>

            <div class="field search-field search-field-fabricante" style="position: relative;">
                <label>FABRICANTE</label>

                <div class="fabricante-search-wrap">
                    <button
                            type="button"
                            class="fabricante-search-icon"
                            title="Buscar fabricante"
                            aria-label="Buscar fabricante"
                            (mousedown)="$event.preventDefault()"
                            (click)="abrirModalFabricantes('busca', $event)">
                        <span class="fabricante-lupa"></span>
                    </button>

                    <input
                            type="text"
                            id="buscaFabricante"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            [(ngModel)]="form.marca"
                            (keyup)="buscarFabricantes(form.marca, 'produto')"
                            (ngModelChange)="monitorarAlteracao()">
                </div>

                <ul id="listaFabricantes" class="listaSug" *ngIf="listaFabricantesProduto.length">
                    <li
                            *ngFor="let fab of listaFabricantesProduto"
                            (click)="selecionarFabricanteProdutoBusca(fab)">
                        {{ fab.descricao }}
                    </li>
                </ul>
            </div>

            <div class="search-actions">
                <button
                        type="button"
                        class="btn btn-limpar"
                        title="Limpar filtros"
                        aria-label="Limpar filtros"
                        (click)="limparBuscaInicial()">
                    <svg class="ico-busca ico-limpar" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M13.013 3H2l8 9.46V19l4 2v-8.54l.9-1.055"/><path d="m22 3-5 5"/><path d="m17 3 5 5"/></svg>
                </button>

                <button
                        type="button"
                        class="btn primary btn-buscar"
                        id="btnBuscar"
                        (click)="buscarProduto(undefined, true)">
                    <svg class="ico-busca ico-lupa" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>
                    Buscar
                </button>
            </div>

        </div>

    </div>

    <!-- LISTA INICIAL DE ÚLTIMAS COTAÇÕES -->
    <div
            class="min"
            *ngFor="let prod of listaUltimasCotacoes; let i = index"
            [hidden]="!mostrarListaCotacoes"
            style="margin-top:20px;">

        <div class="card-produto" style="padding:12px; border:1px solid #ddd; border-radius:8px; margin-bottom:10px;">
            <div class="ed-card-topo">
                <div class="ed-card-img-col" style="cursor:pointer" (click)="selecionarProduto(prod)">
                    <img [src]="prod.imagem" class="produto-img-mini ed-card-img-grande"/>
                    <span class="ed-card-codigo">Código: {{ prod.codigo }}</span>
                </div>

                <div class="ed-card-ident">
                    <div class="field">
                        <label>PART NUMBER</label>
                        <div class="input-copy-wrapper">
                            <input
                                    type="text"
                                    readonly
                                    class="readonly-field"
                                    [value]="prod.partNumber">
                            <button
                                    type="button"
                                    class="btn-copy"
                                    title="Copiar Part Number"
                                    (click)="copiarTexto(prod.partNumber)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                            </button>
                        </div>
                    </div>

                    <div class="field">
                        <label>NOME</label>
                        <input type="text" readonly class="readonly-field" [value]="prod.nome">
                    </div>

                    <div class="field">
                        <label>FABRICANTE</label>
                        <input type="text" readonly class="readonly-field" [value]="prod.fabricante">
                    </div>
                </div>

                <div class="ed-card-acoes">
                    <button type="button" class="ed-btn-acao" (click)="selecionarProduto(prod)" title="Editar este produto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>
                        Editar
                    </button>
                    <button type="button" class="ed-btn-acao ed-btn-clonar" (click)="clonarProdutoDaLista(prod)" title="Cadastrar um novo produto a partir deste (clonar)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                        Clonar
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="field">
                    <label>PRECO FABRICANTE
                        {{
                            (prod.fabricante || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input type="text" readonly class="readonly-field" [value]="prod.preco">
                </div>

                <div class="field">
                    <label>CUSTO (%)</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.custo">
                </div>

                <div class="field">
                    <label>TOTAL CUSTO
                        {{
                            (prod.fabricante || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input type="text" readonly class="readonly-field" [value]="prod.totcusto">
                </div>

                <div class="field">
                    <label>LUCRO (%)</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.lucro">
                </div>

                <div class="field">
                    <label>PRECO VENDA
                        {{
                            (prod.fabricante || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input type="text" readonly class="readonly-field" [value]="prod.venda">
                </div>

                <div class="field">
                    <label>PREÇO VENDA R$</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.vendaReais">
                </div>

                <div class="field">
                    <label>VARIAÇÃO (%)</label>
                    <input
                            type="text"
                            readonly
                            class="readonly-field"
                            [value]="prod.variacao"
                            [ngClass]="{
                              'variacao-positiva': toNumber(prod.variacao) > 0,
                              'variacao-negativa': toNumber(prod.variacao) < 0,
                              'variacao-neutra': toNumber(prod.variacao) == 0
                            }">
                </div>

                <div class="field">
                    <label>CORE
                        {{
                            (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input type="text" readonly class="readonly-field" [value]="prod.core">
                </div>
            </div>

            <div class="row">
                <div class="field" style="width: 80%;">
                    <label>COTAÇÃO REALIZADA EM</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.fornecedor">
                </div>

                <div class="field" style="width:20%">
                    <label>DATA DA ULTIMA COTAÇÃO</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.data">
                </div>

                <div class="field">
                    <label>USUARIO</label>
                    <input type="text" readonly class="readonly-field" [value]="prod.usuario">
                </div>
            </div>

        </div>

    </div>

    <!-- LISTA DE PRODUTOS -->
    <div *ngFor="let prod of listaProdutos" [hidden]="!mostrarLista" style="margin-top:20px;">
        <div class="card-produto produto-busca-card" [class.produto-busca-card-exato]="prod.partNumberExato" (click)="selecionarProduto(prod)">
            <div class="produto-busca-imagem-coluna">
                <img [src]="prod.imagem" class="produto-busca-imagem"/>
                <div class="produto-busca-codigo">{{ prod.codigo }}</div>
            </div>
            <div class="produto-busca-dados">
                <div class="produto-busca-dado texto-grande">
                    <b>Part Number:</b>
                    <div style="display: flex; align-items: center;">
                        <span>{{ prod.partNumber }}</span>
                        <span *ngIf="prod.ativo === 'N' || prod.ativo === 'NÃO' || prod.ativo === false" style="background-color: #ffcccc; color: #cc0000; padding: 1px 4px; font-weight: bold; font-size: 10px; border-radius: 4px; margin-left: 6px; white-space: nowrap;">INATIVO</span>
                    </div>
                </div>
                <div class="produto-busca-dado texto-medio"><b>Descrição:</b><span>{{ prod.nome }}</span></div>
                <div class="produto-busca-dado texto-medio"><b>Fabricante:</b><span>{{ prod.fabricante }}</span></div>
                <div class="produto-busca-dado texto-medio"><b>CD:</b><span>{{ prod.condicao || '-' }}</span></div>
            </div>
            <div class="produto-busca-alternativos" *ngIf="prod.alternativos?.length">
                <div class="produto-busca-alternativos-titulo">Produto Alternativo:</div>
                <div class="produto-busca-alternativos-lista">
                    <button
                            type="button"
                            class="produto-busca-alternativo"
                            *ngFor="let alternativo of prod.alternativos"
                            (click)="selecionarProdutoAlternativoDaBusca(alternativo, $event)">
                        PN: {{ alternativo.partNumber || alternativo.codprod }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Botões de ação movidos pro page-header (barra azul), ver acima. -->

    <!-- LOADING -->
    <div *ngIf="carregando()" class="loading-overlay">
        <app-loading-indicator></app-loading-indicator>
    </div>

    <!-- PRODUTO (mesmos campos e ordem do Cadastrar Produto) -->
    <div class="content-top" *ngIf="telaVisivel">
        <div class="form ed-form">

            <!-- Topo: Ativo + imagem à esquerda; 2 linhas de dados à frente dela -->
            <div class="ed-bloco-topo">
                <div class="ed-bloco-ativo-img">
                    <label class="switch switch-compacto ed-switch-ativo">
                        <input type="checkbox" [checked]="form.ativo" (change)="onToggleAtivoEdicao($event)" name="ativoEdicao">
                        <span class="slider"></span>
                        <span class="switch-text">{{ form.ativo ? 'Ativo' : 'Inativo' }}</span>
                    </label>

                    <div class="img-produto-mini">
                        <input type="file" id="inputImagem" accept="image/*" multiple class="img-file-hidden" #inputImagem (change)="onImagemSelecionada($event)">
                        <span class="img-count-badge"
                              *ngIf="(imagensPendentes.length || listaMiniaturas.length) > 1">
                            {{ imagensPendentes.length || listaMiniaturas.length }}
                        </span>
                        <div class="img-produto-thumb"
                             (click)="cliqueMiniaturaImagem(inputImagem)"
                             [title]="imagensPendentes.length > 0 ? 'Ver imagens selecionadas' : 'Clique para ver/adicionar imagem'">
                            <img [src]="imagemPrincipal?.src" class="img-thumb-img" alt="Imagem do produto">
                        </div>
                    </div>

                    <span class="ed-codigo-produto" *ngIf="codprodTela">Código: {{ codprodTela }}</span>
                </div>

                <div class="ed-coluna-dados">

                    <!-- Linha 1: Fabricante (Marca) | Unidade | toggles -->
                    <div class="ed-linha-topo">
                        <div class="field ed-campo-marca" style="position: relative;">
                            <label>FABRICANTE (MARCA)</label>
                            <div class="fabricante-search-wrap">
                                <button
                                        type="button"
                                        class="fabricante-search-icon"
                                        title="Buscar fabricante"
                                        aria-label="Buscar fabricante"
                                        (mousedown)="$event.preventDefault()"
                                        (click)="abrirModalFabricantes('produto', $event)">
                                    <span class="fabricante-lupa"></span>
                                </button>

                                <input
                                        type="text"
                                        id="buscaFabricanteProduto"
                                        autocomplete="off"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                        [value]="marcaValorInput"
                                        [title]="marcaExibida"
                                        (focus)="onFocusMarcaEdicao($event)"
                                        (input)="onInputMarcaEdicao($event)"
                                        (blur)="onBlurMarcaEdicao($event)">

                                <button type="button" class="fabricante-clear-btn" *ngIf="form.marca || codMarcaEdicao"
                                        (mousedown)="$event.preventDefault()" (click)="limparMarcaEdicao()" title="Limpar">
                                    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="18" y1="6" x2="6" y2="18"></line>
                                        <line x1="6" y1="6" x2="18" y2="18"></line>
                                    </svg>
                                </button>
                            </div>

                            <ul id="listaFabricantesProduto" class="listaSug" *ngIf="listaFabricantesProduto.length">
                                <li *ngFor="let fab of listaFabricantesProduto" (click)="selecionarFabricanteProduto(fab)">
                                    {{ fab.codigo ? fab.codigo + ' - ' : '' }}{{ fab.descricao }}
                                </li>
                            </ul>
                        </div>

                        <div class="field ed-campo-unidade" style="position: relative;" (click)="$event.stopPropagation()">
                            <label>UNIDADE (VOLUME)</label>
                            <input
                                    type="text"
                                    id="buscaVolume"
                                    autocomplete="off"
                                    autocorrect="off"
                                    autocapitalize="off"
                                    spellcheck="false"
                                    [(ngModel)]="form.codVol"
                                    (focus)="abrirVolumes($event)"
                                    (click)="abrirVolumes($event)"
                                    (ngModelChange)="buscarVolumes(form.codVol); monitorarAlteracao()">
                            <ul id="listaVolumes" class="listaSug" *ngIf="volumeDropdownAberto">
                                <li *ngFor="let vol of listaVolumes" (mousedown)="$event.preventDefault(); selecionarVolume(vol)">
                                    {{ vol.descricao }}
                                </li>
                            </ul>
                        </div>

                        <div class="field ed-campo-estoque">
                            <label>ESTOQUE ATUAL</label>
                            <input type="text" readonly class="ed-estoque-input" autocomplete="off"
                                   title="Clique para ver o estoque nas demais filiais"
                                   [value]="estoqueAtualCarregando ? '...' : (estoqueAtual === null ? '—' : (estoqueAtual | number:'1.0-2':'pt-BR'))"
                                   (click)="abrirEstoqueFiliais()">
                        </div>

                        <div class="est-fil-overlay" *ngIf="modalEstFilAberto" (click)="fecharEstoqueFiliais()">
                            <div class="est-fil" (click)="$event.stopPropagation()">
                                <div class="est-fil-header">
                                    <div class="est-fil-titulo">
                                        <div class="est-fil-pn">P/N: {{ form.partNumber || '—' }}</div>
                                        <div class="est-fil-desc">{{ form.descricao }}</div>
                                        <div class="est-fil-cod">Código: {{ form.CODPROD }}</div>
                                    </div>
                                    <button type="button" class="est-fil-fechar" (click)="fecharEstoqueFiliais()" title="Fechar">×</button>
                                </div>
                                <div class="est-fil-corpo">
                                    <div class="est-fil-carregando" *ngIf="modalEstFilCarregando">
                                        <app-loading-indicator></app-loading-indicator>
                                        <span>Carregando estoque das filiais...</span>
                                    </div>
                                    <div class="est-fil-erro" *ngIf="!modalEstFilCarregando && modalEstFilErro">{{ modalEstFilErro }}</div>
                                    <table class="est-fil-tabela" *ngIf="!modalEstFilCarregando && modalEstFilItens.length">
                                        <thead>
                                            <tr><th>Filial</th><th class="est-col-estoque">Estoque</th><th class="est-col-local">Local</th></tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let f of modalEstFilItens" [class.est-atual]="f.atual">
                                                <td>{{ f.empresaId }} - {{ f.empresa }}<span class="est-atual-tag" *ngIf="f.atual">atual</span></td>
                                                <td class="est-col-estoque">{{ f.qtde | number:'1.0-2':'pt-BR' }}</td>
                                                <td class="est-col-local">{{ f.local || '—' }}</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr *ngIf="modalEstFilSemSaldoOutras"><td colspan="3" class="est-sem-saldo">Nenhuma outra filial com saldo deste item.</td></tr>
                                            <tr><td><strong>Total</strong></td><td class="est-col-estoque"><strong>{{ totalEstoqueFiliais | number:'1.0-2':'pt-BR' }}</strong></td><td class="est-col-local"></td></tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <!-- Toggles na mesma ordem do Cadastrar: Lote, Série, Controla FORM, Perigoso, CORE -->
                        <div class="ed-toggles">
                            <label class="switch switch-compacto">
                                <input type="checkbox" [checked]="form.tipContest === 'L'" (change)="onToggleTipoControle('L', $event)" name="tipContest_lote">
                                <span class="slider"></span>
                                <span class="switch-text">Lote</span>
                            </label>
                            <label class="switch switch-compacto">
                                <input type="checkbox" [checked]="form.tipContest === 'E'" (change)="onToggleTipoControle('E', $event)" name="tipContest_serie">
                                <span class="slider"></span>
                                <span class="switch-text">Serial</span>
                            </label>
                            <label class="switch switch-compacto">
                                <input type="checkbox" [checked]="form.controlaForm === 'S'" (change)="onToggleSN('controlaForm', $event)" name="controlaForm">
                                <span class="slider"></span>
                                <span class="switch-text">Controla FORM</span>
                            </label>
                            <label class="switch switch-compacto">
                                <input type="checkbox" [checked]="form.matPerig === 'S'" (change)="onToggleSN('matPerig', $event)" name="matPerig">
                                <span class="slider"></span>
                                <span class="switch-text">Perigoso</span>
                            </label>
                        </div>
                    </div>

                    <!-- Linha 2: Part Number | Descrição | CD -->
                    <div class="ed-linha-pn">
                        <div class="field ed-campo-pn">
                            <label>PN (PART NUMBER)</label>
                            <input type="text" style="text-transform: uppercase;" [ngModel]="form.partNumber" (ngModelChange)="form.partNumber = ($event || '').toUpperCase(); monitorarAlteracao()">
                        </div>

                        <div class="field ed-campo-descricao">
                            <label>DESCRIÇÃO</label>
                            <input type="text" style="text-transform: uppercase;" [ngModel]="form.descricao" (ngModelChange)="onDescricaoChange($event)">
                        </div>

                        <div class="field ed-campo-cd" style="position: relative;" (click)="$event.stopPropagation()">
                            <label>CD (CONDITION KEY)</label>
                            <select id="buscaCondicao" [(ngModel)]="form.condicao" [title]="labelCondicao(form.condicao)"
                                    (ngModelChange)="monitorarAlteracao()">
                                <option value="">-- Selecione --</option>
                                <option *ngFor="let o of opcoesCondicaoCombo" [value]="o.valor">{{ o.label }}</option>
                            </select>
                        </div>
                    </div>
                </div><!-- /ed-coluna-dados -->
            </div><!-- /ed-bloco-topo -->

            <!-- Linha 3: Produtos Alternativos | Dados Internacionais | Local + Grupo -->
            <div class="ed-linha-alt-intl-local">

                <div class="field ed-coluna-alternativos">
                    <label>PRODUTOS ALTERNATIVOS</label>
                    <div
                            class="produtos-alternativos-select"
                            role="listbox"
                            aria-label="Produtos alternativos"
                            aria-multiselectable="true"
                            tabindex="0"
                            (click)="abrirModalProdutosAlternativos()"
                            (keydown.enter)="abrirModalProdutosAlternativos()"
                            (keydown.space)="$event.preventDefault(); abrirModalProdutosAlternativos()">
                        <div class="produtos-alternativos-valores">
                            <span
                                    class="produto-alternativo-chip"
                                    role="option"
                                    aria-selected="true"
                                    *ngFor="let produto of produtosAlternativos">
                                PN: {{ produto.partNumber || produto.codprod }}
                                <button
                                        type="button"
                                        class="produto-alternativo-remover"
                                        title="Desvincular produto alternativo"
                                        (click)="solicitarDesvincularProdutoAlternativo(produto, $event)">x</button>
                            </span>
                            <span class="produtos-alternativos-placeholder" *ngIf="produtosAlternativos.length === 0">
                                Clique para adicionar produtos alternativos
                            </span>
                        </div>
                        <span class="produtos-alternativos-seta" aria-hidden="true"></span>
                    </div>
                </div>

                <div class="ed-card-dados-intl">
                    <span class="ed-card-dados-intl-titulo">DADOS INTERNACIONAIS</span>
                    <div class="field">
                        <label>LABEL (USA)</label>
                        <input type="text" style="text-transform: uppercase;" maxlength="100" [ngModel]="form.labelUsa" (ngModelChange)="onLabelUsaChange($event)">
                    </div>
                    <div class="ed-card-dados-intl-linha">
                        <div class="field ed-campo-intl">
                            <label>ECCN</label>
                            <input type="text" style="text-transform: uppercase;" [ngModel]="form.eccn" (ngModelChange)="form.eccn = ($event || '').toUpperCase(); monitorarAlteracao()">
                        </div>
                        <div class="field ed-campo-intl">
                            <label>SCHEDULE B</label>
                            <input type="text" [(ngModel)]="form.scheduleB" (ngModelChange)="monitorarAlteracao()">
                        </div>
                        <!-- Sigla em inglês da Unidade (TGFVOL.GPL_SIGLAINGLES), automática -->
                        <div class="field ed-campo-unit-measure">
                            <label>Unit of Measure:</label>
                            <input type="text" class="readonly-field ed-unit-measure-input" readonly
                                   [value]="unidadeInglesAtual()?.siglaIngles || ''"
                                   [title]="unidadeInglesAtual()?.nomeIngles || ''"
                                   tabindex="-1">
                        </div>
                    </div>
                </div>

                <div class="ed-coluna-local">
                    <div class="field" style="position: relative;">
                        <label>LOCAL (ESTOQUE)</label>
                        <div class="fabricante-search-wrap">
                            <button
                                    type="button"
                                    class="fabricante-search-icon"
                                    title="Buscar Local"
                                    aria-label="Buscar Local"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="abrirBuscaLocalModal()">
                                <span class="fabricante-lupa"></span>
                            </button>

                            <input
                                    type="text"
                                    readonly
                                    class="readonly-field"
                                    [value]="form.codLocalPadraoDescricao || ''"
                                    placeholder="Selecione o Local..."
                                    (click)="abrirBuscaLocalModal()"
                                    style="cursor: pointer;">

                            <button
                                    type="button"
                                    class="produtos-alternativos-marca-limpar"
                                    *ngIf="form.codLocalPadrao"
                                    title="Limpar Local"
                                    (click)="$event.stopPropagation(); limparLocalPadrao()">x</button>
                        </div>
                    </div>

                    <div class="field">
                        <label>GRUPO DE PRODUTO</label>
                        <div class="fabricante-search-wrap">
                            <button
                                    type="button"
                                    class="fabricante-search-icon"
                                    title="Buscar Grupo de Produto"
                                    aria-label="Buscar Grupo de Produto"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="abrirBuscaGrupo()">
                                <span class="fabricante-lupa"></span>
                            </button>

                            <input
                                    type="text"
                                    readonly
                                    class="readonly-field"
                                    [value]="valorExibidoGrupo(form.codGrupo)"
                                    placeholder="Selecione o Grupo..."
                                    (click)="abrirBuscaGrupo()"
                                    style="cursor: pointer;">

                            <button
                                    type="button"
                                    class="produtos-alternativos-marca-limpar"
                                    *ngIf="form.codGrupo"
                                    title="Limpar Grupo"
                                    (click)="$event.stopPropagation(); limparGrupo()">x</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Linha 4: Polícia Federal | Peso Bruto | Peso Líquido | NCM -->
            <div class="ed-linha-pf-pesos-ncm">
                <div class="ed-policia-card" title="PORTARIA Nº 240, DE 12 DE MARÇO DE 2019&#10;&#10;IV - São isentas de controle as soluções eletrolíticas de bateria formuladas à base de até 40% de ácido sulfúrico, destinadas ao varejo e em embalagens de até 1 (um) litro, sendo o limite de isenção para pessoa jurídica a quantidade de 200 (duzentos) litros e para a pessoa física a quantidade de 5 (cinco) litros, por mês.">
                    <span class="ed-policia-titulo">POLÍCIA FEDERAL</span>
                    <div class="ed-policia-body">
                        <label class="switch switch-compacto">
                            <input type="checkbox" [checked]="form.controlado === 'S'" (change)="onToggleControlado($event)" name="controlado">
                            <span class="slider"></span>
                            <span class="switch-text">Controlado</span>
                        </label>
                        <div class="field ed-campo-limite">
                            <label>LIMITE PF</label>
                            <input type="text" class="readonly-field" [value]="form.controlado === 'S' ? form.limitePF : ''" disabled>
                        </div>
                        <div class="field ed-campo-limite">
                            <label>LIMITE PJ</label>
                            <input type="text" class="readonly-field" [value]="form.controlado === 'S' ? form.limitePJ : ''" disabled>
                        </div>
                    </div>
                </div>

                <div class="field ed-campo-peso">
                    <label>PESO BRUTO</label>
                    <input type="text" inputmode="decimal" [(ngModel)]="form.pesoBruto" name="pesoBruto"
                           (ngModelChange)="monitorarAlteracao()"
                           (focus)="onPesoFocus('pesoBruto')" (blur)="onPesoBlur('pesoBruto')">
                </div>
                <div class="field ed-campo-peso">
                    <label>PESO LÍQUIDO</label>
                    <input type="text" inputmode="decimal" [(ngModel)]="form.pesoLiq" name="pesoLiq"
                           (ngModelChange)="monitorarAlteracao()"
                           (focus)="onPesoFocus('pesoLiq')" (blur)="onPesoBlur('pesoLiq')">
                </div>

                <div class="field ed-campo-ncm">
                    <label>NCM</label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" (click)="abrirBuscaNcm()" title="Buscar NCM">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input"
                               [value]="valorExibidoNcm(form.ncm)"
                               [title]="valorExibidoNcm(form.ncm)"
                               (input)="onInputNcm($event)"
                               name="ncm">
                        <button type="button" class="busca-combo-clear" *ngIf="form.ncm" (click)="limparNcm()" title="Limpar">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Preço + Cotação (mesma ordem do Cadastrar) -->
            <div class="ed-preco-grid" [class.ed-preco-nacional]="isMarcaNacional">
                <div class="field">
                    <input type="hidden" id="CODPROD" [(ngModel)]="form.CODPROD">
                    <input type="hidden" id="COTACAOALTERADA" [(ngModel)]="form.cotacaoalterada">
                    <label>PREÇO FABRICANTE
                        {{
                            (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input
                            type="text"
                            id="precoFabricante"
                            step="0.01"
                            [(ngModel)]="form.precoFabricante"
                            (blur)="calcular()"
                            (focus)="removerVirgulaCampo('precoFabricante')">
                </div>
                <div class="field">
                    <label>CUSTO (%)</label>
                    <input
                            type="text"
                            id="percentualCusto"
                            step="0.01"
                            [(ngModel)]="form.percentualCusto"
                            (blur)="calcular()"
                            (focus)="removerVirgulaCampo('percentualCusto')">
                </div>
                <div class="field">
                    <label>TOTAL CUSTO
                        {{
                            (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input
                            type="text"
                            id="totalCusto"
                            readonly
                            class="readonly-field"
                            step="0.01"
                            [(ngModel)]="form.totalCusto"
                            (ngModelChange)="marcarAlterado()">
                </div>
                <div class="field">
                    <label>LUCRO (%)</label>
                    <input
                            type="text"
                            id="percentualLucro"
                            step="0.01"
                            [(ngModel)]="form.percentualLucro"
                            (blur)="calcular()"
                            (focus)="removerVirgulaCampo('percentualLucro')">
                </div>
                <div class="field">
                    <label>PREÇO VENDA
                        {{
                            (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                            ? 'R$'
                            : 'U$'
                        }}
                    </label>
                    <input
                            type="text"
                            id="precoVenda"
                            readonly
                            class="readonly-field"
                            step="0.01"
                            [(ngModel)]="form.precoVenda">
                </div>
                <div class="field" *ngIf="!isMarcaNacional">
                    <label [title]="cotacaoDolarDia > 0 ? ('Cotação do dólar: R$ ' + (cotacaoDolarDia | number:'1.2-2':'pt-BR')) : 'Cotação do dólar indisponível'">
                        PREÇO VENDA R$
                        <span class="cotacao-dolar-label" *ngIf="cotacaoDolarDia > 0">
                            (COTAÇÃO: U$ {{ cotacaoDolarDia | number:'1.2-2':'pt-BR' }})
                        </span>
                    </label>
                    <input
                            type="text"
                            id="precoVendaReais"
                            readonly
                            class="readonly-field"
                            [value]="precoVendaEmReais || '—'">
                </div>
                <div class="field ed-campo-core">
                    <label class="switch switch-compacto ed-core-toggle" title="Tem CORE">
                        <input type="checkbox" [(ngModel)]="form.temCore" (ngModelChange)="!form.temCore ? form.valorCore = '0.00' : null; monitorarAlteracao()" name="temCorePreco">
                        <span class="slider"></span>
                    </label>
                    <div class="ed-core-coluna">
                        <label class="ed-core-titulo">CORE
                            {{
                                (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                                ? 'R$'
                                : 'U$'
                            }}
                        </label>
                        <input
                                type="text"
                                id="valorCore"
                                [class.readonly-field]="!form.temCore"
                                [readonly]="!form.temCore"
                                [(ngModel)]="form.valorCore"
                                (blur)="formatarCampo('valorCore')">
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="(form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'">
                <div class="aviso-reais">
                    <span class="bandeira-brasil" aria-label="Bandeira do Brasil">
                        <span class="bandeira-losango">
                            <span class="bandeira-circulo"></span>
                        </span>
                    </span>
                    <span class="aviso-reais-icone">
                        <span>!</span>
                    </span>
                    <span class="aviso-reais-texto">
                        OS VALORES DESTE FABRICANTE DEVEM SER DEFINIDOS EM REAIS R$.
                    </span>
                    <span class="aviso-reais-icone"><span>!</span></span>
                    <span class="bandeira-brasil" aria-label="Bandeira do Brasil">
                        <span class="bandeira-losango">
                            <span class="bandeira-circulo"></span>
                        </span>
                    </span>
                </div>
            </div>

            <div class="row">
                <div class="field" style="flex: 90; position: relative;" (click)="$event.stopPropagation()">
                    <label>COTAÇÃO REALIZADA EM:</label>
                    <input
                            type="text"
                            id="buscaFornecedor"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            spellcheck="false"
                            [(ngModel)]="form.fornecedor"
                            (focus)="abrirFornecedores($event)"
                            (click)="abrirFornecedores($event)"
                            (ngModelChange)="buscarFornecedores(form.fornecedor); monitorarAlteracao()">
                    <ul id="listaFornecedores" class="listaSug" *ngIf="fornecedorDropdownAberto">
                        <li *ngFor="let fornec of listaFornecedores" (mousedown)="$event.preventDefault(); selecionarFornecedor(fornec)">
                            {{ fornec.descricao }}{{ fornec.cnpj ? ' - ' + fmtDocFornecedor(fornec.cnpj) : '' }}
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Observações: Interna + Técnica (fim, igual ao Cadastrar) -->
            <div class="row">
                <div class="field">
                    <label>OBS. INTERNA</label>
                    <textarea [(ngModel)]="form.obsInterna" (ngModelChange)="monitorarAlteracao()" rows="4"></textarea>
                </div>
                <div class="field">
                    <label>OBS. TÉCNICA PARA O VENDEDOR</label>
                    <textarea [(ngModel)]="form.obsTecnica" (ngModelChange)="monitorarAlteracao()" rows="4"></textarea>
                </div>
            </div>
        </div>
    </div>

    <!-- Modal Grupo de Produto -->
    <div class="modal-overlay" *ngIf="modalGrupoAberto">
        <div class="modal-box modal-busca">
            <div class="modal-header">Procurando por Grupo de Produto</div>
            <div class="modal-body">
                <input type="text" class="busca-modal-input" [(ngModel)]="filtroGrupoModal" name="filtroGrupoModal"
                       placeholder="Digite o que você procura">
                <div class="busca-modal-lista">
                    <div class="busca-modal-item" *ngFor="let g of gruposFiltrados" (click)="selecionarGrupo(g)">
                        {{ g.label }}
                    </div>
                    <div class="busca-modal-empty" *ngIf="gruposFiltrados.length === 0">Nenhum grupo encontrado.</div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="modal-btn confirm" (click)="fecharBuscaGrupo()">Cancelar</button>
            </div>
        </div>
    </div>

    <!-- Modal NCM -->
    <div class="modal-overlay" *ngIf="modalNcmAberto">
        <div class="modal-box modal-busca">
            <div class="modal-header">Procurando por NCM</div>
            <div class="modal-body">
                <input type="text" class="busca-modal-input" [(ngModel)]="filtroNcmModal" name="filtroNcmModal"
                       placeholder="Digite pelo menos 3 caracteres para buscar">
                <div class="busca-modal-lista">
                    <div class="busca-modal-item" *ngFor="let n of ncmsFiltrados" (click)="selecionarNcm(n)">
                        {{ n.label }}
                    </div>
                    <div class="busca-modal-empty" *ngIf="ncmsFiltrados.length === 0">
                        <span *ngIf="filtroNcmModal.trim().length < 3">Digite ao menos 3 caracteres para filtrar.</span>
                        <span *ngIf="filtroNcmModal.trim().length >= 3">Nenhum NCM encontrado.</span>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="modal-btn confirm" (click)="fecharBuscaNcm()">Cancelar</button>
            </div>
        </div>
    </div>

    <!-- Avisos de permissão de edição de cotação
    <div *ngIf="telaVisivel">
        <div *ngIf="!cotacaoEditavel" class="aviso-reais" style="background:#fee2e2; border-color:#f87171; color:#991b1b; margin-top:8px;">
            <span style="font-size:18px;">🔒</span>
            <span class="aviso-reais-texto">Você não possui permissão para editar cotações. Contate o administrador.</span>
        </div>
        <div *ngIf="podeEditarCotacaoSomenteParaCima && !podeEditarCotacao" class="aviso-reais" style="background:#fef9c3; border-color:#fde047; color:#713f12; margin-top:8px;">
            <span style="font-size:18px;">⬆️</span>
            <span class="aviso-reais-texto">Permissão restrita: você pode editar apenas para CIMA (não é permitido diminuir o preço atual).</span>
        </div>
    </div>
    -->

    <!-- ABAS -->
    <div class="tabs" *ngIf="telaVisivel">
        <div class="tab-header">
            <button class="tab-btn" [class.active]="abaAtiva === 'tab1'" (click)="trocarTab('tab1')">
                ÚLTIMAS COTAÇÕES
            </button>
            <!--
            <button
                    class="tab-btn"
                    [class.active]="abaAtiva === 'tab2'"
                    (click)="trocarTab('tab2')">
                Estoque
            </button>
            -->
        </div>
        <div id="tab1" class="tab-content" *ngIf="abaAtiva === 'tab1'">
            <div *ngIf="cotacoes.length === 0 && !carregando()">
                Nenhuma cotação encontrada
            </div>
            <div *ngFor="let cot of cotacoes">
                <div class="row">
                    <div class="field flex-2">
                        <label>COTAÇÃO REALIZADA EM</label>
                        <input [value]="cot.fornecedor" readonly>
                    </div>
                    <div class="field">
                        <label>DATA DA COTAÇÃO</label>
                        <input [value]="cot.data" readonly>
                    </div>
                    <div class="field">
                        <label>Preço
                            {{
                                (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                                ? 'R$'
                                : 'U$'
                            }}
                        </label>
                        <input [value]="cot.preco" readonly>
                    </div>
                    <div class="field">
                        <label>Variação (%)</label>
                        <input
                                [value]="cot.variacao"
                                [ngClass]="{
                                'variacao-positiva': toNumber(cot.variacao) > 0,
                                'variacao-negativa': toNumber(cot.variacao) < 0,
                                'variacao-neutra': toNumber(cot.variacao) == 0
                        }" readonly>
                    </div>
                    <div class="field flex-2">
                        <label>Core
                            {{
                                (form.marca || '').trim().toUpperCase() === 'EMBRAER (NEIVA)'
                                ? 'R$'
                                : 'U$'
                            }}
                        </label>
                        <input [value]="cot.core" readonly>
                    </div>
                    <div class="field flex-2">
                        <label>Usuário</label>
                        <input [value]="cot.usuario" readonly>
                    </div>
                </div>
            </div>
        </div>
        <div id="tab2" class="tab-content" *ngIf="abaAtiva === 'tab2'">
            <div class="row">
                <div class="field flex-2">
                    <label>Estoque</label>
                    <input readonly class="readonly-field" [value]="form.estoque">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- MODAL PRODUTOS ALTERNATIVOS -->
<div class="modal-overlay produtos-alternativos-modal-overlay" *ngIf="modalProdutosAlternativosAberto">
    <div class="modal-box produtos-alternativos-modal" (click)="$event.stopPropagation()">
        <div class="modal-header produtos-alternativos-modal-header">
            <div>
                <strong>Produtos Alternativos</strong>
                <span>Busque e selecione um ou mais produtos</span>
            </div>
            <button type="button" class="produtos-alternativos-modal-close" (click)="solicitarFecharModalProdutosAlternativos()">x</button>
        </div>

        <div class="modal-body produtos-alternativos-modal-body">
            <div class="produtos-alternativos-filtros">
                <label class="produtos-alternativos-termo">
                    Produto
                    <input
                            type="text"
                            [(ngModel)]="filtroProdutoAlternativo"
                            (input)="aoDigitarProdutoAlternativo()"
                            placeholder="Código, Part Number ou descrição">
                </label>
                <label>
                    Marca
                    <div class="fabricante-search-wrap produtos-alternativos-marca-search">
                        <input
                                type="text"
                                [value]="marcaProdutoAlternativoDescricao"
                                placeholder="Todas as marcas"
                                readonly
                                (click)="abrirModalFabricantes('alternativo', $event)">
                        <button
                                type="button"
                                class="produtos-alternativos-marca-limpar"
                                *ngIf="marcaProdutoAlternativo"
                                title="Limpar fabricante"
                                (click)="$event.stopPropagation(); marcaProdutoAlternativo = ''; marcaProdutoAlternativoDescricao = ''; buscarProdutosAlternativosModal()">x</button>
                    </div>
                </label>
            </div>

            <div class="produtos-alternativos-selecionados" *ngIf="produtosAlternativosSelecionados.length">
                <span *ngFor="let produto of produtosAlternativosSelecionados">
                    PN: {{ produto.partNumber || produto.codprod }}
                    <button type="button" (click)="alternarProdutoAlternativo(produto)">x</button>
                </span>
            </div>

            <div class="produtos-alternativos-loading" *ngIf="carregandoProdutosAlternativos">
                <app-loading-indicator></app-loading-indicator> Carregando produtos...
            </div>

            <div class="produtos-alternativos-lista" *ngIf="!carregandoProdutosAlternativos">
                <div class="alt-resultados-container">
                    <table class="alt-table" *ngIf="produtosAlternativosBusca.length > 0">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Código</th>
                            <th>Part Number</th>
                            <th>Marca</th>
                            <th>Descrição</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let prod of produtosAlternativosBusca" (click)="alternarProdutoAlternativo(prod)"
                            [class.alt-selecionado]="produtoAlternativoSelecionado(prod)">
                            <td>
                                <input type="checkbox" [checked]="produtoAlternativoSelecionado(prod)" (click)="$event.stopPropagation()" (change)="alternarProdutoAlternativo(prod)">
                            </td>
                            <td>{{ prod.codprod }}</td>
                            <td [title]="prod.partNumber">{{ prod.partNumber }}</td>
                            <td [title]="prod.marca">{{ prod.marca }}</td>
                            <td>{{ prod.descricao }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="alt-empty-state" *ngIf="produtosAlternativosBusca.length === 0">
                        Nenhum produto encontrado.
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="modal-btn cancel" (click)="solicitarFecharModalProdutosAlternativos()">Cancelar</button>
            <button
                    type="button"
                    class="modal-btn confirm"
                    [disabled]="!produtosAlternativosSelecionados.length || salvandoProdutosAlternativos"
                    (click)="salvarProdutosAlternativos()">
                <app-loading-indicator *ngIf="salvandoProdutosAlternativos" size="inline"></app-loading-indicator>
                {{ salvandoProdutosAlternativos ? 'Salvando...' : 'Salvar' }}
            </button>
        </div>
    </div>
</div>
<!-- MODAL FABRICANTES -->
<!-- Modal "Procurando por Marca" (idêntico ao do Cadastro) -->
<div class="mm-overlay" *ngIf="modalFabricantesAberto" (click)="fecharModalFabricantes()">
    <div class="mm-box" (click)="$event.stopPropagation()">
        <div class="mm-header">Procurando por Marca</div>
        <div class="mm-body">
            <input type="text"
                   class="mm-input"
                   [(ngModel)]="filtroFabricanteModal"
                   (ngModelChange)="buscarFabricantesModal($event)"
                   placeholder="Digite o que você procura"
                   autofocus>

            <div class="mm-lista">
                <div class="mm-item"
                     *ngFor="let fab of listaFabricantesModal"
                     (click)="selecionarFabricanteModal(fab)">
                    {{ fab.codigo ? fab.codigo + ' - ' : '' }}{{ fab.descricao }}
                </div>
                <div class="mm-empty" *ngIf="carregandoFabricantesModal">Carregando...</div>
                <div class="mm-empty" *ngIf="!carregandoFabricantesModal && listaFabricantesModal.length === 0">
                    Nenhuma marca encontrada.
                </div>
            </div>
        </div>
        <div class="mm-footer">
            <button type="button" class="mm-btn" (click)="fecharModalFabricantes()">Cancelar</button>
        </div>
    </div>
</div>
<!-- MODAL CONFIRM -->
<div class="modal-overlay modal-confirm-overlay" *ngIf="modalConfirm">
    <div class="modal-box">
        <div class="modal-header">Confirmação</div>
        <div class="modal-body">
            {{ modalMensagem }}
        </div>
        <div class="modal-footer">
            <button class="modal-btn cancel" (click)="fecharModal()">Cancelar</button>
            <button class="modal-btn confirm" (click)="confirmarModal()">Confirmar</button>
        </div>
    </div>
</div>

<!-- MODAL BUSCA DE LOCAIS -->
<div class="ds-modal-overlay" *ngIf="modalLocaisAberto" (click)="fecharBuscaLocalModal()">
    <div class="ds-modal ds-modal--sm" (click)="$event.stopPropagation()">
        <div class="ds-modal-header">
            <h3 class="ds-modal-title">Locais de Estoque</h3>
            <button type="button" class="ds-modal-close" (click)="fecharBuscaLocalModal()">×</button>
        </div>
        <div class="ds-modal-body" style="display: flex; flex-direction: column; gap: 15px;">
            <div class="ds-search">
                <input type="text" class="ds-input"
                       [(ngModel)]="filtroLocalInput"
                       (ngModelChange)="buscarLocais($event)"
                       placeholder="Filtrar locais...">
            </div>
            <div class="ds-table-container" style="max-height: 300px;">
                <table class="ds-table ds-table--compact ds-table--striped" style="min-width: unset;">
                    <tbody>
                        <tr *ngFor="let loc of listaLocaisFiltrados" (click)="selecionarLocal(loc)" style="cursor: pointer;">
                            <td>{{ loc.valor }} - {{ loc.label }}</td>
                        </tr>
                        <tr *ngIf="listaLocaisFiltrados.length === 0">
                            <td class="ds-table-empty">Nenhum local encontrado.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="ds-modal-footer">
            <button type="button" class="ds-btn" (click)="fecharBuscaLocalModal()">Fechar</button>
        </div>
    </div>
</div>

<!-- MODAL: atualizar a data do preço mesmo sem mudança de valor? (igual ao Aerosys) -->
<div class="modal-overlay" *ngIf="modalDataPreco">
    <div class="modal-box">
        <div class="modal-header">Confirmação</div>
        <div class="modal-body">
            Deseja atualizar a Data do Preço do Produto, mesmo não havendo mudança no valor?
        </div>
        <div class="modal-footer">
            <button class="modal-btn" (click)="responderDataPreco(false)">Não</button>
            <button class="modal-btn confirm" (click)="responderDataPreco(true)">Sim</button>
        </div>
    </div>
</div>

<!-- MODAL OK -->
<div class="modal-overlay" *ngIf="modalOk">
    <div class="modal-box">
        <div class="modal-header">Aviso</div>
        <div class="modal-body">
            {{ modalMensagemOk }}
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharModalOk()">OK</button>
        </div>
    </div>
</div>
<!-- MODAL AVISO -->
<div class="modal-overlay" *ngIf="modalAv">
    <div class="modal-box">
        <div class="modal-header">Aviso</div>
        <div class="modal-body">
            {{ modalMensagemAv }}
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharModalAv()">OK</button>
        </div>
    </div>
</div>
<!-- MODAL ERRO -->
<div class="modal-overlay" *ngIf="modalErro">
    <div class="modal-box">
        <div class="modal-header">Aviso</div>
        <div class="modal-body">
            {{ modalMensagemErro }}
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharModalErro()">OK</button>
        </div>
    </div>
</div>
<!-- MODAL SALVAR IMAGEM -->
<div class="img-modal-overlay" *ngIf="mostrarModalImagem">
    <div class="img-modal-box">
        <img [src]="previewImagem" class="img-modal-preview"/>
        <div class="img-modal-actions">
            <button
                    class="img-btn save"
                    (click)="confirmarSalvarImagem(false)"
                    [disabled]="isPlaceholder">
                Salvar
            </button>
            <button
                    class="img-btn default"
                    (click)="confirmarSalvarImagem(true)">
                Salvar e padrão
            </button>
            <button
                    class="img-btn cancel"
                    (click)="cancelarImagem()">
                Cancelar
            </button>
        </div>
    </div>
</div>
<!-- MODAL SELECAO DE IMAGENS (mesmo layout do Cadastrar Produto) -->
<div class="img-modal-overlay cad-img" *ngIf="mostrarModalSelecaoImagem">
    <div class="img-selecao-box">

        <div class="img-selecao-header">
            <span>Imagens selecionadas</span>
            <span class="img-selecao-contador" *ngIf="imagensPendentes.length > 1">
                {{indexVisualizandoPendente + 1}} / {{imagensPendentes.length}}
            </span>
        </div>

        <div class="img-selecao-principal">
            <img [src]="imagensPendentes[indexVisualizandoPendente]?.src" class="img-selecao-preview" alt="">
            <span class="img-selecao-badge-principal" *ngIf="indexPadrao === indexVisualizandoPendente">PADRÃO</span>
            <button type="button" class="img-selecao-remove-principal"
                    *ngIf="imagensPendentes.length === 1"
                    (click)="removerImagemPendente(0, $event)" title="Remover imagem">✕</button>
        </div>

        <div class="img-selecao-tira" *ngIf="imagensPendentes.length > 1">
            <div class="img-selecao-mini"
                 *ngFor="let img of imagensPendentes; let i = index"
                 [class.ativa]="i === indexVisualizandoPendente"
                 [class.padrao]="i === indexPadrao"
                 (click)="indexVisualizandoPendente = i">
                <img [src]="img.src" alt="">
                <span class="img-mini-padrao-badge" *ngIf="indexPadrao === i">✓</span>
                <button type="button" class="img-selecao-remove"
                        (click)="removerImagemPendente(i, $event)" title="Remover">✕</button>
            </div>
        </div>

        <div class="img-selecao-hint-obrig" *ngIf="indexPadrao < 0">
            ⚠ Selecione a imagem padrão para continuar
        </div>

        <div class="img-selecao-actions">
            <input type="file" accept="image/*" multiple class="img-file-hidden" #inputAdicionar (change)="onImagemSelecionada($event)">
            <button class="img-btn default" type="button"
                    [class.ja-padrao]="indexPadrao === indexVisualizandoPendente"
                    (click)="indexPadrao = indexVisualizandoPendente">
                {{indexPadrao === indexVisualizandoPendente ? '✓ Padrão' : 'Definir Padrão'}}
            </button>
            <button class="img-btn default" type="button" (click)="inputAdicionar.click()">+ Adicionar</button>
            <button class="img-btn cancel" type="button" (click)="cancelarImagem()">Limpar</button>
            <button class="img-btn save" type="button"
                    [disabled]="indexPadrao < 0"
                    (click)="confirmarSalvarImagem()">Confirmar</button>
        </div>
    </div>
</div>
<!-- MODAL GALERIA (mesmo layout do modal de imagens do Cadastrar Produto) -->
<div class="img-modal-overlay cad-img" *ngIf="modalGaleria">
    <div class="img-selecao-box">

        <div class="img-selecao-header">
            <span>Imagens do produto</span>
            <span class="img-selecao-contador" *ngIf="listaImagens.length > 1">
                {{ indexImagem + 1 }} / {{ listaImagens.length }}
            </span>
        </div>

        <div class="img-selecao-principal">
            <img [src]="imagemAtual?.src" class="img-selecao-preview" alt="Imagem do produto">
            <span class="img-selecao-badge-principal" *ngIf="imagemAtual?.imgId === listaImagens[0]?.imgId">PADRÃO</span>
        </div>

        <div class="img-selecao-tira" *ngIf="listaImagens.length > 1">
            <div class="img-selecao-mini"
                 *ngFor="let img of listaImagens; let i = index"
                 [class.ativa]="i === indexImagem"
                 [class.padrao]="i === 0"
                 (click)="indexImagem = i; imagemAtual = listaImagens[i]">
                <img [src]="img.src" alt="">
                <span class="img-mini-padrao-badge" *ngIf="i === 0">✓</span>
            </div>
        </div>

        <div class="img-selecao-actions">
            <button class="img-btn default" type="button"
                    [class.ja-padrao]="imagemAtual?.imgId === listaImagens[0]?.imgId"
                    (click)="definirComoPadrao(imagemAtual, true)">
                {{ imagemAtual?.imgId === listaImagens[0]?.imgId ? '✓ Padrão' : 'Definir Padrão' }}
            </button>
            <button class="img-btn default" type="button" (click)="adicionarImagemDaGaleria()">+ Adicionar</button>
            <button class="img-btn cancel" type="button"
                    (click)="deletarImg(imagemAtual)"
                    [disabled]="!imagemAtual || ehPlaceholder(imagemAtual)">Excluir</button>
            <button class="img-btn save" type="button" (click)="fecharGaleria()">Sair</button>
        </div>
    </div>
</div>
<div id="toast-container"></div>
